/**
 * Moderation service for custom scenarios.
 * Enforces PG-13 content guidelines suitable for minors / high school students.
 */

export const MODERATION_ERROR_MESSAGE =
  "Errore: Il contenuto inserito non rispetta le linee guida di sicurezza per minori. L'operazione è stata annullata.";

export class ContentModerationError extends Error {
  constructor(message = MODERATION_ERROR_MESSAGE, category = null) {
    super(message);
    this.name = "ContentModerationError";
    this.category = category;
    this.isModerationViolation = true;
  }
}

// Prohibited themes regex patterns (case-insensitive)
const PROHIBITED_PATTERNS = [
  // 1. Volgarità, turpiloquio o linguaggio offensivo
  {
    category: "profanity",
    regex: /\b(cazz[oiea]|merd[ae]|stronz[oiea]|puttan[ae]|troi[ae]|coglione?|coglioni|vaffanculo|fanculo|vaffan|fottiti|fottere|minchi[ae]|bastard[oiea]|baldracca|zoccola|mignotta|dio\s*(cane|porco|boia|bestia)|porc[oa]\s*(dio|madonna)|fuck|shit|bitch|asshole|cunt|motherfucker|dick|pussy)\b/i
  },

  // 2. Violenza esplicita o grafica
  {
    category: "violence",
    regex: /\b(omicidi[oi]|assassini[oi]|assassin[oiea]|strag[ei]|massacr[oi]|tortur[ae]|decapitazion[ei]|smembrament[oi]|sparatori[ae]|accoltella(re|to|ti|mento)|mutilazion[ei]|terroris(mo|ta|ti)|attentat[oi]|genocidi[oi]|carneficin[ei]|splatter|gore|squartamento|massacre|murder|slaughter|torture|beheading)\b/i
  },

  // 3. Contenuti a sfondo sessuale, espliciti o allusivi
  {
    category: "sexual_content",
    regex: /\b(sess[oi]|sessual[ei]|porn(o|ografia|ografico)|erotic[oi]|nudit[aà]|nudo|nuda|nudi|scopare|chiavare|prostitut[ae]|prostituzione|escort|bordell[oi]|strip\s*club|molesti[ae]\s*sessual[ei]|stupr[oi]|stupratore|pedofili[ae]|incest[oi]|hardcore|onlyfans|red\s*light|xxx|hentai)\b/i
  },

  // 4. Riferimenti a droghe, sostanze illegali, abuso di alcol o gioco d'azzardo
  {
    category: "drugs_alcohol_gambling",
    regex: /\b(drog[ae]|drogat[oiea]|cocain[ae]|eroin[ae]|marijuana|cannabis|canne|spinell[oi]|hashish|spacci(o|are|atore|atori)|pusher|stupefacent[ei]|metanfetamin[ae]|meth|crack|lsd|ecstasy|estasi|overdose|allucinogen[oi]|siringh[ae]\s*di\s*droga|abuso\s*d['i]\s*alcol|ubriac(arsi|atura|oni)|alcolis(mo|ta)|sbornia|coma\s*etilic[oi]|scommess[ae]\s*(clandestin[ae]|illegal[ei])|gioco\s*d['']azzardo|azzard[oi]|casin[oò]|slot\s*machine|roulette|bookmaker|bische\s*clandestin[ae]|scommettere\s*soldi|poker\s*d['']azzardo)\b/i
  },

  // 5. Incitamento all'odio, discriminazione, bullismo o autolesionismo
  {
    category: "hate_bullying_selfharm",
    regex: /\b(razzis(mo|ta|ti)|negr[oiea]|frocio?|finocchio?|ricchione?|negro|negri|ebreacci[oi]|nazi|nazis(mo|ta|ti)|fascis(mo|ta|ti)|antisemitis(mo|ta)|omofobi[ae]|transfobi[ae]|bullis(mo|ta|ti)|cyberbullis(mo|ta)|suicidi[oi]|suicidar(si|ti)|impiccar(si|ti)|sparar(si|ti)|tagliar(si|ti)|autolesionis(mo|ta)|pro-ana|anoressia\s*indotta)\b/i
  }
];

/**
 * Validates custom scenario text against prohibited content rules.
 * @param {string} text 
 * @returns {{ isValid: boolean, reason?: string, category?: string }}
 */
export function validateCustomScenario(text) {
  if (!text || typeof text !== "string") {
    return { isValid: true };
  }

  const cleanText = text.trim();
  if (!cleanText) {
    return { isValid: true };
  }

  for (const item of PROHIBITED_PATTERNS) {
    if (item.regex.test(cleanText)) {
      return {
        isValid: false,
        reason: MODERATION_ERROR_MESSAGE,
        category: item.category
      };
    }
  }

  return { isValid: true };
}
